






































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { ClinicDepartment, ClinicResponse } from '@/interface/api'
import {
  IsFirstTreatmentRadioOption,
  TreatmentCategory,
  TreatmentCategoryOption
} from '@/utils/constants'
import sanitize from 'sanitize-html'

import {
  filterTreatmentCourseCategory,
  filterTreatmentFirstTreatment
} from './utils'

@Component({
  name: 'TreatmentDetailTemplate'
})
export default class TreatmentDetailTemplate extends Vue {
  @Prop({ default: () => null }) private selectedClinic!: ClinicResponse
  @Prop({ default: '' }) private clinicalDepartmentId!: string
  @Prop({ default: 1 }) private firstTreatment!: 0 | 1
  @Prop({ default: '' }) private treatmentCategoryName!:
    | ''
    | 'face_to_face'
    | 'video'

  @Prop({ default: false }) private loading!: boolean
  @Prop({ default: false }) private canFaceToFace!: boolean
  @Prop({ default: false }) private canOnlineTreatment!: boolean
  @Prop({ default: '' }) private treatmentCourseId!: string
  @Prop({ default: '' }) private isSingleClinic!: boolean

  private selectedClinicalDepartmentId = ''
  private isFirstTreatment: 0 | 1 = 1
  private selectedTreatmentCategoryName: '' | 'face_to_face' | 'video' = ''
  private selectedClinicDeaprtmentTreatmentCourseId = ''
  private isDescriptionExpanded = false
  private showWelcomeModal = false

  private get selectedDepartment(): ClinicDepartment | undefined {
    return this.selectedClinic.clinical_departments.find(
      item => item.id === this.selectedClinicalDepartmentId
    )
  }

  private get descriptionDisplayMode(): 'hidden' | 'always' | 'accordion' {
    return this.selectedDepartment?.description_display_mode || 'hidden'
  }

  private get truncatedDescription(): string {
    const description = this.selectedDepartment?.description || ''
    // 15文字以内に改行があるかチェック
    const first15Chars = description.slice(0, 15)
    const newlineIndex = first15Chars.search(/[\n\r]/)

    if (newlineIndex !== -1) {
      // 改行が見つかった場合、改行の手前で切る
      return description.slice(0, newlineIndex) + '...'
    } else if (description.length > 15) {
      // 改行がなく15文字以上の場合
      return description.slice(0, 15) + '...'
    }
    // 15文字以下で改行もない場合はそのまま
    return description
  }

  private toggleDescriptionExpanded(): void {
    this.isDescriptionExpanded = !this.isDescriptionExpanded
  }

  private get welcomeMessageStorageKey(): string {
    return `welcome_modal_shown_${this.selectedClinic?.clinic?.id || ''}`
  }

  private get hasWelcomeMessage(): boolean {
    const message = this.selectedClinic?.clinic?.reservation_welcome_message
    return Boolean(message && message.trim())
  }

  private get sanitizedWelcomeMessage(): string {
    const message = this.selectedClinic?.clinic?.reservation_welcome_message
    if (!message) return ''
    return sanitize(message)
  }

  private checkAndShowWelcomeModal(): void {
    if (!this.hasWelcomeMessage) return

    const alreadyShown = sessionStorage.getItem(this.welcomeMessageStorageKey)
    if (alreadyShown) return

    this.showWelcomeModal = true
  }

  private closeWelcomeModal(): void {
    this.showWelcomeModal = false
    sessionStorage.setItem(this.welcomeMessageStorageKey, 'true')
  }

  private mounted(): void {
    this.checkAndShowWelcomeModal()
  }

  private get isFirstTreatmentRadioOption(): typeof IsFirstTreatmentRadioOption {
    return IsFirstTreatmentRadioOption
  }

  private get treatmentCategoryOption(): typeof TreatmentCategoryOption {
    const option = []
    const department = this.selectedClinic.clinical_departments.find(
      item => item.id === this.selectedClinicalDepartmentId
    )
    if (this.canFaceToFace && department?.has_face_to_face) {
      const target = TreatmentCategoryOption.find(
        option => option.name === TreatmentCategory.FcaeToFace
      )
      option.push(target!)
    }
    if (this.canOnlineTreatment && department?.has_video) {
      const target = TreatmentCategoryOption.find(
        option => option.name === TreatmentCategory.Video
      )
      option.push(target!)
    }
    this.selectedTreatmentCategoryName = option[0].value as
      | 'face_to_face'
      | 'video'
    return option
  }

  private get treatmentCourseOptions() {
    if (this.selectedClinicalDepartmentId === '') {
      return []
    }
    if (!this.selectedTreatmentCategoryName) {
      return []
    }
    const department = this.selectedClinic.clinical_departments.find(
      item => item.id === this.selectedClinicalDepartmentId
    )
    if (!department) {
      return []
    }
    if (!department.treatment_courses) {
      return []
    }
    const target = department.treatment_courses
      .filter(course =>
        filterTreatmentCourseCategory(
          course,
          this.selectedTreatmentCategoryName as 'face_to_face' | 'video'
        )
      )
      .filter(course =>
        filterTreatmentFirstTreatment(course, this.isFirstTreatment)
      )
    if (target.length) {
      if (
        !target.find(
          v => v.id === this.selectedClinicDeaprtmentTreatmentCourseId
        )
      ) {
        this.selectedClinicDeaprtmentTreatmentCourseId = target[0].id || ''
      }
    } else if (!target.length) {
      this.selectedClinicDeaprtmentTreatmentCourseId = ''
    }
    return target
  }

  @Watch('clinicalDepartmentId', { immediate: true })
  private onClinicalDepartmentIdChange() {
    if (!this.clinicalDepartmentId) return
    this.selectedClinicalDepartmentId = this.clinicalDepartmentId
  }

  @Watch('firstTreatment', { immediate: true })
  private onFirstTreatmentChange() {
    this.isFirstTreatment = this.firstTreatment
  }

  @Watch('treatmentCategoryName', { immediate: true })
  private onTreatmentCategoryNameChange() {
    if (!this.treatmentCategoryName) return
    this.selectedTreatmentCategoryName = this.treatmentCategoryName
  }

  @Watch('treatmentCourseId', { immediate: true })
  private onTreatmentCourseIdChange() {
    this.selectedClinicDeaprtmentTreatmentCourseId = this.treatmentCourseId
  }

  @Watch('selectedClinicalDepartmentId', { immediate: true })
  private onChangeDepartmentId() {
    this.selectedClinicDeaprtmentTreatmentCourseId = ''
    this.isDescriptionExpanded = false
  }
}
